"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ListCheckIcon = function ListCheckIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8513 0.667414C4.54488 0.412062 4.08947 0.453463 3.83412 0.759885L2.53428 2.31785L2.01074 1.79489L1.9427 1.7348C1.65938 1.51451 1.24972 1.53454 0.989366 1.79489C0.707321 2.07693 0.707321 2.53422 0.989366 2.81626L2.0727 3.8996L2.13985 3.95901C2.44235 4.19515 2.88576 4.15421 3.13821 3.85126L4.94377 1.6846L4.99744 1.6114C5.19118 1.30929 5.13415 0.903123 4.8513 0.667414ZM15.2223 3.43016C15.2223 3.03128 14.8989 2.70793 14.5001 2.70793H7.27783L7.19361 2.71279C6.83442 2.75451 6.55561 3.05977 6.55561 3.43016C6.55561 3.82903 6.87896 4.15238 7.27783 4.15238H14.5001L14.5843 4.14752C14.9435 4.1058 15.2223 3.80054 15.2223 3.43016ZM15.2223 12.0556C15.2223 11.6567 14.8989 11.3333 14.5001 11.3333H5.11119L5.02696 11.3382C4.66777 11.3799 4.38896 11.6852 4.38896 12.0556C4.38896 12.4544 4.71231 12.7778 5.11119 12.7778H14.5001L14.5843 12.7729C14.9435 12.7312 15.2223 12.426 15.2223 12.0556ZM14.5001 7.00002C14.8989 7.00002 15.2223 7.32337 15.2223 7.72225C15.2223 8.09263 14.9435 8.39789 14.5843 8.43961L14.5001 8.44447H5.11119C4.71231 8.44447 4.38896 8.12112 4.38896 7.72225C4.38896 7.35187 4.66777 7.0466 5.02696 7.00488L5.11119 7.00002H14.5001ZM1.50005 8.44447H2.9445V7.00002H1.50005V8.44447ZM2.9445 12.7778H1.50005V11.3333H2.9445V12.7778Z",
    fill: color
  }));
};
var _default = ListCheckIcon;
exports.default = _default;